import { Component, OnInit, AfterViewInit } from '@angular/core';

import { AuthenticationService } from '../../../../app/services/authentication.service';
import { AlertService } from '../../../../app/utils/alert.service';
import { BindComponentService } from '../../../../app/utils/bind.component.service';

/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 63831 2017-09-23 17:42:15Z edivaldo.m.junior $
 */
@Component({
  templateUrl: './content.template.html'
})
export class StepsComponent implements OnInit, AfterViewInit {

  private loggedManagerType: string;

  constructor(private authService : AuthenticationService , private alertService: AlertService, private bindComponent: BindComponentService) {
    
  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'STEPS_FILTER'); //ALTERADO
  }

  ngAfterViewInit()  {
    this.loadView();
    setTimeout(() => {
      for (let i = 1; i <= 6 ; i++) {
        let col_left_name = String('col-left-').concat(i.toString());
        let col_right_name = String('col-right-').concat(i.toString());
        if( (null !== document.getElementById(col_left_name)) && (null !== document.getElementById(col_right_name)) ) {
          let col_left = document.getElementById(col_left_name);
          let col_right = document.getElementById(col_right_name);    
          let left_height = col_left.offsetHeight;
          let right_height = col_right.offsetHeight;
          let height_offset = (left_height > right_height)? left_height : right_height;
          let style = document.createElement("style");
          document.head.appendChild(style);
          let sheet = style.sheet;
          let ua = window.navigator.userAgent;
          let msie = ua.indexOf("MSIE ");
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            // If Internet Explorer, return version number
            (sheet as CSSStyleSheet).addRule('#'+col_right_name,'min-height: '+height_offset+'px !important;');
          } else {
            // If another browser, return 0  
            (sheet as CSSStyleSheet).insertRule('#'+col_right_name+' { min-height: '+height_offset+'px !important; }');
          }
        }
      }
    }, 10);
  }
  private loadView() {
    this.loggedManagerType = "";
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if (!isNil(data)) {
      this.loggedManagerType = data['loggedManagerType'];
    }
    function isNil(value) {
      return value == null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/steps/content.component.ts